import generateCropRegularInspectionReducer from "./generateCropRegularInspectionReducer";

const generateRegularInspectionReducers = {
    generateCropRegularInspection: generateCropRegularInspectionReducer
}

export default generateRegularInspectionReducers;